module.exports = __webpack_public_path__ + "static/media/hin.adfa9c30.jpg";